module.exports = __webpack_public_path__ + "assets/-_17.38795b2c.svg";